export const FLAMINGO = '#EB5424';
export const POMEGRANATE = '#FF3E00';
export const IRON = '#CACBCD';
export const MERCURY = '#E3E5E7';
export const MOUNTAIN_MEADOW = '#01B48F';
export const SPICY_MUSTARD = '#786600';
export const MANGO_TANGO = '#FF8F46';

// ALIAS
export const GREEN = MOUNTAIN_MEADOW;
export const PINK = '#c879b2';
export const BLUE = '#44c7f4';

// @okjake FIXME: Use color names using an app like http://sipapp.io/
export const LIGHT_GREEN = '#C3FFFF';
export const LIGHT_PINK = '#FFDFFF';
export const LIGHT_BLUE = '#AAFFFF';
